import { render, staticRenderFns } from "./notasActa.vue?vue&type=template&id=4cb0508e"
import script from "./notasActa.vue?vue&type=script&lang=js"
export * from "./notasActa.vue?vue&type=script&lang=js"
import style0 from "./notasActa.vue?vue&type=style&index=0&id=4cb0508e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports